import CryptoJS from 'crypto-js'
import randomBytes from 'randombytes'

const encryptionPrefix = 'contexted|'
const salt = 'salt'

const calculateClientKey = passphrase => CryptoJS.PBKDF2(passphrase, salt, { keySize: 256 / 32 }).toString()
const encrypt = (unencryptedMessage, key) => {
  return CryptoJS.AES.encrypt(encryptionPrefix + unencryptedMessage, key).toString()
}

const decrypt = (encryptedMessage, key) => {
  const decryptedMessage = CryptoJS.AES.decrypt(encryptedMessage, key).toString(CryptoJS.enc.Utf8)
  if (!decryptedMessage.startsWith(encryptionPrefix)) throw new Error('Message doesn\'t have valid encryption')
  return decryptedMessage.substring(encryptionPrefix.length)
}

const generateEncryptionKey = () => {
  return randomBytes(16).toString('hex')
}

const verifyClientKey = (encryptedEncryptionKey, clientKey) => {
  try {
    if (!encryptedEncryptionKey) throw new Error('Encryption key is null')
    if (!clientKey) throw new Error('Client key is null')
    decrypt(encryptedEncryptionKey, clientKey)
    return true
  } catch (e) {
    console.log(e)
    return false
  }
}

const encryptNote = (note, key) => ({
  ...note,
  title: encrypt(note.title, key),
  content: encrypt(note.content, key)
})

const decryptNote = (note, key) => ({
  ...note,
  title: decrypt(note.title, key),
  content: decrypt(note.content, key)
})

const encryptNotes = (notes, key) => {
  return Object.keys(notes).reduce((encryptedNotes, noteId) => {
    const note = notes[noteId]
    encryptedNotes[noteId] = encryptNote(note, key)
    return encryptedNotes
  }, {})
}

const decryptNotes = (notes, key) => {
  return Object.keys(notes).reduce((encryptedNotes, noteId) => {
    const note = notes[noteId]
    encryptedNotes[noteId] = decryptNote(note, key)
    return encryptedNotes
  }, {})
}

export {
  calculateClientKey,
  encrypt,
  decrypt,
  generateEncryptionKey,
  verifyClientKey,
  encryptNotes,
  decryptNotes
}
